import { CustodianStatementLink } from "@/shared/types";

export const taxLink: CustodianStatementLink = {
  url: "/cash-account/statements",
  target: "_self"
};

export const statementsLink = taxLink;

export const footerTemplate = "HsaBankInvestmentsFooter";

export const profileEditInformationHtml = "";

export const investmentRiskDisclaimer = null;

export const displayMyProfileEditMode = true;

export const logoutRedirectUrl = null;

export const faqTemplate = "AvidiaForms";

export const faqInstructionsTemplate = "AvidiaFormsInstructions";

export const faqLinkAddress = "";

export const displayAdvice = true;

export const displayFaqExternalLinks = true;

export const displayFaqInstructions = false;

export const displayInvestmentsSection = true;

export const disabledRouteRedirectTarget = null;

export const displaySettingsLinkedAccounts = true;

export const contactDetailsSetAtBank = false;

export const allowEmailEdit = true;

export const priorYearContributionOption = true;

export const allowReimbursement = true;

export const showPendingReimbursements = true;

export const showAlternateOnboardingCompleteMessage = false;

const disabledRoutesDictionary = {};

export const disabledRoutes = disabledRoutesDictionary;

// update the lob letter sender to use updated URL Helpers.PortalSupportConstants/AvidiaNoDisclosureUrl
export const termsUrl = "/AvidiaTerms_20240701.pdf";

export const feeTemplate = "AvidiaTermsFeeSchedule";

export const quarterlyPaperStatementFee = 2.25;

export const manageHsaCardsInPortal = true;

export const displayPriorYearContributionDisclaimerCopy = false;

export const displayProjectedContributions = true;

export const allowUserToEditContributions = true;

export const displayPdfForESign = false;

export const displayHealthcareBluebookLink = false;

export const displayFooterLegalSection = true;

export const showHsaStoreShopTab = true;

export const displayHealthcareClaims = true;